<div class="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Sign in to your account
        </h2>
      </div>
      <form class="max-w-md mx-auto mt-8 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
              Email
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="email"
              type="email"
              placeholder="Email"
              formControlName="email"
              autocomplete="username"
            />
            @if ((f.email.touched || submitted)  && (f.email.hasError('required') || f.email.hasError('whitespace'))) {
              <span class="text-xs text-red-400 m-0 p-0">Email is <strong>required</strong></span>
            }
        </div>
        <div class="mb-4" >
            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
              Password
            </label>
            <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="password"
              type="password"
              placeholder="Password"
              formControlName="password"
              autocomplete="current-password"
            />
            @if ((f.password.touched || submitted)  && (f.password.hasError('required') || f.password.hasError('whitespace'))) {
              <span class="text-xs text-red-400 m-0 p-0">Password is <strong>required</strong></span>
            }
        </div>
        <div>
            <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm rounded-md text-white bg-[#E31C79] hover:bg-rose-700 font-normal focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" [disabled]="disableBtn">
              <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                <!-- Heroicon name: solid/lock-closed -->
                <!-- <svg class="h-8 w-8 text-gray-500 group-hover:text-rose-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 12a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path>
                  <path d="M4 8V6a4 4 0 014-4h4a4 4 0 014 4v2h1a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h1zm4-2V6a2 2 0 00-2-2h4a2 2 0 00-2 2v2h2a1 1 0 011 1v5H7v-5a1 1 0 011-1h2z"></path>
                </svg> -->
              </span>
              Sign in
            </button>
        </div>
        <div class="text-center py-2">
            <p class="text-sm text-gray-600">
                Don't have an account? 
                <button type="button" class=" text-sm text-indigo-500 font-normal focus:outline-none" routerLink="signup">
                  Sign up
                </button>
            </p>
        </div>
      </form>
    </div>
  </div>
  